module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "daily-events"
    }
  }, [(_vm.valid_calendar_id && !_vm.loading) ? _c('div', [_c('div', {
    staticClass: "daily_events_header"
  }, [_vm._v("AGENDA - " + _vm._s(_vm.current_user.name))]), _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "change-date"
  }, [_c('button', {
    staticClass: "btn-default",
    attrs: {
      "disabled": _vm.current_day
    },
    on: {
      "click": function($event) {
        return _vm.changeDay(-1)
      }
    }
  }, [_vm._v("<")])]), _c('div', {
    staticClass: "current-day"
  }, [_vm._v(_vm._s(_vm.pad(_vm.search_date.getDate())) + " / " + _vm._s(_vm.pad(_vm.search_date.getMonth() + 1)) + " / " + _vm._s(_vm.search_date.getFullYear()))]), _c('div', {
    staticClass: "change-date"
  }, [_c('button', {
    staticClass: "btn-default",
    on: {
      "click": function($event) {
        return _vm.changeDay(+1)
      }
    }
  }, [_vm._v(">")])]), _c('div', {
    staticClass: "current-day weekday"
  }, [_vm._v(_vm._s(_vm.weekday))])]), _c('div', {
    staticClass: "zones internal-scroller",
    style: ({
      maxHeight: _vm.height + 'px'
    })
  }, [_c('table', [_c('tbody', _vm._l((_vm.hours), function(zone) {
    return _c('tr', {
      key: zone.hour,
      staticClass: "zone"
    }, [_c('td', {
      staticClass: "hour"
    }, [_vm._v(_vm._s(_vm.pad(zone.hour)) + ":00")]), _vm._l((zone.events), function(event) {
      return (zone.events.length > 0) ? _c('td', {
        key: event.id,
        staticClass: "event",
        attrs: {
          "rowspan": event.size
        }
      }, [_c('div', {
        staticClass: "event_name"
      }, [_vm._v(_vm._s(event.title))]), _c('div', {
        staticClass: "event_duration"
      }, [_vm._v(_vm._s(event.start_time) + " - " + _vm._s(event.end_time))])]) : _vm._e()
    })], 2)
  }), 0)])])]) : (_vm.loading) ? _c('div', {
    staticClass: "override",
    style: ({
      maxHeight: _vm.height + 86 + 'px',
      minHeight: _vm.height + 86 + 'px'
    })
  }, [_c('div', {
    staticClass: "center"
  }, [_c('span', [_c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  })], 1)])]) : _c('div', {
    staticClass: "override",
    style: ({
      maxHeight: _vm.height + 'px',
      minHeight: _vm.height + 'px'
    })
  }, [(_vm.current_user.id == _vm.default_user.id) ? _c('div', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Para utilizar a integração com o seu Calendar, é necessário se conectar com o seu cliente de e-mail.")]), _c('div', [_c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.redirect
    }
  }, [_vm._v("Conectar")])])]) : _c('div', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Para agendar a reunião para outro usuário é necessário que ele se conecte com o cliente de e-mail.")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-475e7b9d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/daily_events.vue
// module id = 1098
// module chunks = 1